import React from 'react';
import { Link } from 'react-router-dom';
import './CommunityFloatingComposerButton.css';

const CommunityFloatingComposerButton: React.FC = () => {
  return (
  <Link to="/app/community/compose" className="community-shell__fab" aria-label="创建新帖子">
      ✍️
    </Link>
  );
};

export default CommunityFloatingComposerButton;
